var _linearGradient, _linearGradient2, _path, _linearGradient3, _path2, _linearGradient4, _path3, _linearGradient5, _path4, _linearGradient6, _path5, _linearGradient7, _path6, _linearGradient8, _circle, _linearGradient9, _path7, _linearGradient10, _path8, _linearGradient11, _path9, _linearGradient12, _path10, _linearGradient13, _path11, _linearGradient14, _path12, _linearGradient15, _path13, _linearGradient16, _path14, _linearGradient17, _path15, _linearGradient18, _path16, _linearGradient19, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtraSalaries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 20 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 1278.794,
    y1: -1200.07,
    x2: 1279.794,
    y2: -1200.07
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 1278.794,
    y1: -1200.07,
    x2: 1279.794,
    y2: -1200.07
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M160.503 113.386v40.062h-13.385v-40.062z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 83.215,
    y1: 55.564,
    x2: 94.551,
    y2: 55.564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.315 51.759s-.79-4.666-4.552-4.662-4.768 4.671-4.768 4.671l9.776 7.591",
    fill: "none",
    stroke: "url(#SVGID_2_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 83.215,
    y1: 55.564,
    x2: 94.551,
    y2: 55.564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.451 59.368s.79 4.666 4.552 4.662 4.768-4.671 4.768-4.671",
    fill: "none",
    stroke: "url(#SVGID_3_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 83.215,
    y1: 55.564,
    x2: 94.551,
    y2: 55.564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M88.872 43.122l.004 3.975"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 83.215,
    y1: 55.564,
    x2: 94.551,
    y2: 55.564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M88.891 64.03l.003 3.975"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 57.128,
    y1: 118.033,
    x2: 102.024,
    y2: 118.033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M100.774 123.302v1.74H58.378v-14.019H90.48"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 65.642,
    y1: 55.587,
    x2: 111.915,
    y2: 55.587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.779,
    cy: 55.587,
    r: 21.886,
    fill: "none",
    stroke: "url(#SVGID_7_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 94.033,
    y1: 122.363,
    x2: 96.533,
    y2: 122.363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M95.283 120.962v2.801"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 87.2,
    y1: 117.913,
    x2: 89.7,
    y2: 117.913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_9_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M88.45 112.062v11.701"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 69.228,
    y1: 117.913,
    x2: 71.728,
    y2: 117.913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_10_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M70.478 112.062v11.701"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 78.027,
    y1: 117.913,
    x2: 80.527,
    y2: 117.913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_11_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M79.277 112.062v11.701"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 62.395,
    y1: 117.913,
    x2: 64.895,
    y2: 117.913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_12_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M63.645 112.062v11.701"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 78.819,
    y1: 102.275,
    x2: 123.715,
    y2: 102.275,
    gradientTransform: "rotate(-14.211 72.523 146.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_13_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M87.273 104.376l-16.541 4.189-3.442-13.59 16.541-4.189 18.418-4.665 6.14-1.554 3.442 13.589-6.14 1.555z"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 115.724,
    y1: 102.155,
    x2: 118.224,
    y2: 102.155,
    gradientTransform: "rotate(-14.211 72.523 146.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_14_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M103.321 86.922l2.873 11.342"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 108.891,
    y1: 102.155,
    x2: 111.391,
    y2: 102.155,
    gradientTransform: "rotate(-14.211 72.523 146.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_15_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M96.697 88.6l2.873 11.342"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 90.918,
    y1: 102.155,
    x2: 93.418,
    y2: 102.155,
    gradientTransform: "rotate(-14.211 72.523 146.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_16_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M79.275 93.012l2.873 11.342"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 99.717,
    y1: 102.155,
    x2: 102.217,
    y2: 102.155,
    gradientTransform: "rotate(-14.211 72.523 146.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_17_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M87.805 90.852l2.872 11.342"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3",
    gradientUnits: "userSpaceOnUse",
    x1: 84.085,
    y1: 102.155,
    x2: 86.585,
    y2: 102.155,
    gradientTransform: "rotate(-14.211 72.523 146.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_18_86784ce1e0707e2687a035b1bc9627f6283c871c60846ac4b1c8a62ee2c46fb3)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M72.651 94.69l2.873 11.342"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M145.91 119.482l-7.818.092c-3.625-6.602-8.565-6.946-8.565-6.946l.172.017-29.57-5.976a7.505 7.505 0 00-2.973 14.711l20.575 4.158.03.109-.944 4.801-19.626 8.399-15.678.044-27.233-13.768a7.504 7.504 0 00-6.888 13.334l35.365 19.632h30.713l24.052-11.101h9.158"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraSalaries);
export default __webpack_public_path__ + "static/media/extraSalaries.e52c6d8649c888af11bb4d165400750e.svg";
export { ForwardRef as ReactComponent };